import * as React from "react";
import {formatDateTimeString} from "../../utils/date.utils";
import {useTranslation} from "react-i18next";
import ExpenseDelete from "../expense-delete/ExpenseDelete";
import ExpenseEditDialog from "../expense-edit-dialog/ExpenseEditDialog";
import ExpenseDto from "../../dto/ExpenseDto";
import {ExpensePrintButton} from "../print-button/ExpensePrintButton";
import ExpensePreviewDialog from "../expense-preview-dialog/ExpensePreviewDialog";
import Box from "@mui/material/Box";
import {Card, CardContent, Grid} from "@mui/material";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";

interface Props {
    rowIndex: number;
    row: ExpenseDto;
    onChange: () => void;
}

export default function ExpenseListRow(props: Props) {
    const {t} = useTranslation();
    const {
        rowIndex,
        row,
        onChange
    } = props;

    return (
        <Grid item xs={12} key={row.id}>
            <Card sx={{boxShadow: 3}}>
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center" sx={{mt: 1}}>
                        <Typography variant="body2" color="text.secondary">
                            {rowIndex + 1}.
                        </Typography>
                        <Typography
                            variant="subtitle2"
                            color="text.secondary"
                        >
                            {formatDateTimeString(row.createdAt)}
                        </Typography>
                    </Box>
                    <Box display="flex" flexDirection="column" gap={1}>
                        <Typography variant="body2" sx={{mb: 1}}>
                            <strong>Note:</strong> {row.note}
                        </Typography>
                        <ExpensePreviewDialog context={'text'} id={row.id} fileName={row.fileName}/>
                    </Box>
                    <Box
                        display="flex"
                        justifyContent="flex-end"
                        alignItems="center"
                        gap={1}
                        sx={{mt: 2}}
                    >
                        <Tooltip title="Edit">
                            <ExpenseEditDialog expense={row} onSave={onChange}/>
                        </Tooltip>
                        <Tooltip title="Delete">
                            <ExpenseDelete row={row}/>
                        </Tooltip>
                        <Tooltip title="Preview File">
                            <ExpensePreviewDialog context={'icon'} id={row.id} fileName={row.fileName}/>
                        </Tooltip>
                        <Tooltip title="Print File">
                            <ExpensePrintButton id={row.id} fileName={row.fileName}/>
                        </Tooltip>
                    </Box>
                </CardContent>
            </Card>
        </Grid>
    );
}